<div class="dc-modal">
  <div class="dc-modal-container bg-white min-w-3xs! max-w-[600px]!">
    <button (click)="onClose.emit()" type="button" class="modal-x-button">
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "SECTION_NOTES" | translate }}
    </h1>
    <form [formGroup]="form">
      <div class="notes fields-container">
        @if(allowSubmit){
        <div class="field-control">
          <app-text-field
            [type]="'big-text'"
            [label]="'LABEL_NOTES' | translate"
            [control]="form.get('noteControl')!"
            [maxlength]="1000"
          />
        </div>
        <div>
          @if(!isSubmitting){
          <app-button
            [label]="'BUTTONS.SUBMIT_NOTE' | translate"
            classesName="btn-edge-cut btn-width-auto"
            (onBtnClick)="submitNote()"
          ></app-button>
          } @if(isSubmitting){
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
        </div>
        }

        <!-- Notes list -->
        <div class="notes__list">
          @if(isLoading){
          <app-skeleton-loader
            [formLoader]="true"
            [noOfFields]="2"
          ></app-skeleton-loader>
          } @if(notes && notes.length > 0){
          <h2 class="font-semibold">
            {{ "LIST_OF_SUBMITTED_NOTES" | translate }}
          </h2>
          } @for (note of notes; track $index) { @if(note.Note){
          <div class="notes__item">
            <div class="notes__meta">
              @if(note[ "Note Type"]){
              <span
                class="notes__type"
                [ngClass]="
                  note['Note Type'] != fieldValue.NOTE_TYPE_AGENT &&
                  note['Note Type'] != fieldValue.NOTE_TYPE_AGENT_AR
                    ? 'notes__note_agent'
                    : ''
                "
                >{{ note["Note Type"] }}</span
              >
              }
              <span class="notes__date">
                {{ note["DC Created"] | date : "dd-MMM-yyyy hh:mm a" }}
              </span>
            </div>
            <p class="notes__text">{{ note.Note }}</p>
          </div>
          } } @if(!isLoading && notes.length < 1){
          <div class="notes__empty">
            {{ "NOTES_NOT_FOUND" | translate }}
          </div>
          }
        </div>

        <div class="flex">
          <app-button
            type="button"
            classesName="card-edge-cut-white btn-width-auto"
            [label]="'BUTTONS.CLOSE' | translate"
            (onBtnClick)="onClose.emit()"
          ></app-button>
        </div>
      </div>
    </form>
  </div>
</div>
